// extracted by mini-css-extract-plugin
export default {"container":"Tile_container__v6aJc"};